import { SVGProps, forwardRef } from 'react';

/**
 * Custom record icon: an outer ring with a large filled core.
 *
 * Matches Lucide's SVG defaults so it slots into our icon registry
 * and inherits the same `size-*` sizing and `currentColor` theming.
 */
export const Record = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(
  (props, ref) => (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <circle cx="12" cy="12" r="10" />
      <circle cx="12" cy="12" r="5" fill="currentColor" stroke="none" />
    </svg>
  ),
);
